import { render, staticRenderFns } from "./SendButton.vue?vue&type=template&id=7b2ee77b&"
import script from "./SendButton.vue?vue&type=script&lang=ts&"
export * from "./SendButton.vue?vue&type=script&lang=ts&"
import style0 from "./SendButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports